import { React } from 'react';
import { Input } from '@chakra-ui/react';

function InputBox({
  value,
  onChange,
  onBlur,
  type = 'text',
  width = '100%',
  borderColor = 'inherits',
  disabled,
  visibility = 'visible',
}) {
  return (
    <Input
      fontSize='12px'
      borderRadius='48px'
      bg='gray.50'
      minHeight='40px'
      width={width}
      textAlign='center'
      value={value || ''}
      type={type}
      onChange={onChange}
      onBlur={onBlur}
      borderColor={borderColor}
      // Having min max limit numbers to integer and within a reasonable range
      min='0'
      max='100000'
      // When mousewheel used + input type number, blur it to prevent changing number by scrolling
      onWheel={e => type === 'number' && e.target.blur()}
      disabled={disabled}
      visibility={visibility}
    />
  );
}

export default InputBox;
